import React, { useState, useEffect } from 'react';
import axios from '../api/axiosInstance'; // ✅ axios avec token
import { useNavigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import {
  Box, Typography, TextField, MenuItem, Button, Paper, Alert, Grid
} from '@mui/material';
import '../css/AddUser.css';

const AddUser = () => {
  const [formData, setFormData] = useState({
    gender: '',
    firstName: '',
    lastName: '',
    emailAddress: '',
    password: '',
    phoneNumber: '',
    arrive: '',
    userType: 'user',
    societe: ''
  });

  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [societes, setSocietes] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const checkAdmin = async () => {
      try {
        const res = await axios.get('/users/current-user');
        if (res.data.userType !== 'admin') navigate('/404');
      } catch (err) {
        navigate('/404');
      }
    };

    const fetchSocietes = async () => {
      try {
        const res = await axios.get('/societes');
        setSocietes(res.data);
      } catch (err) {
        console.error('Erreur chargement sociétés :', err);
      }
    };

    checkAdmin();
    fetchSocietes();
  }, [navigate]);

  const handleChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post('/users', formData);
      setSuccess("Utilisateur ajouté avec succès");
      setError('');
      setTimeout(() => navigate('/manage-users'), 1000);
    } catch (err) {
      if (err.response?.status === 400 && err.response.data.message === 'User already exists') {
        setError("Compte existe déjà avec cette adresse mail");
      } else {
        setError("Erreur lors de l'ajout de l'utilisateur");
      }
      setSuccess('');
    }
  };

  return (
    <Box className="add-user-container">
      <Sidebar />
      <Box className="main-content">
        <Paper className="add-user-paper" elevation={3}>
          <Typography variant="h5" gutterBottom>Ajouter un utilisateur</Typography>

          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}

          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4}>
                <TextField
                  select name="gender" label="Genre" fullWidth required
                  value={formData.gender} onChange={handleChange}
                >
                  <MenuItem value="">Sélectionner...</MenuItem>
                  <MenuItem value="Monsieur">Monsieur</MenuItem>
                  <MenuItem value="Madame">Madame</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  name="firstName" label="Prénom" fullWidth required
                  value={formData.firstName} onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  name="lastName" label="Nom" fullWidth required
                  value={formData.lastName} onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  type="email" name="emailAddress" label="Email" fullWidth required
                  value={formData.emailAddress} onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  type="password" name="password" label="Mot de passe" fullWidth required
                  value={formData.password} onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  name="phoneNumber" label="Téléphone" fullWidth required
                  value={formData.phoneNumber} onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  select name="arrive" label="Type" fullWidth required
                  value={formData.arrive} onChange={handleChange}
                >
                  <MenuItem value="ESN">ESN</MenuItem>
                  <MenuItem value="Freelance">Freelance</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  select name="userType" label="Rôle" fullWidth required
                  value={formData.userType} onChange={handleChange}
                >
                  <MenuItem value="user">Utilisateur</MenuItem>
                  <MenuItem value="admin">Admin</MenuItem>
                </TextField>
              </Grid>

              {formData.arrive === 'ESN' && (
                <Grid item xs={12}>
                  <TextField
                    select name="societe" label="Société" fullWidth required
                    value={formData.societe} onChange={handleChange}
                  >
                    <MenuItem value="">Sélectionner une société</MenuItem>
                    {societes.map(s => (
                      <MenuItem key={s._id} value={s._id}>{s.nom}</MenuItem>
                    ))}
                  </TextField>
                </Grid>
              )}

              <Grid item xs={12}>
                <Button type="submit" variant="contained" className="add-user-btn">
                  Ajouter l'utilisateur
                </Button>
              </Grid>
            </Grid>
          </form>
        </Paper>
      </Box>
    </Box>
  );
};

export default AddUser;
